import translationEN from '../../assets/locales/en/translation.json';
import translationFR from "../../assets/locales/fr/translation.json";
import translationPL from "../../assets/locales/pl/translation.json";

import jQuery from 'jquery'

import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { enqueueSnackbar } from 'notistack';
import {State} from '../../components/grid/BasicGridState'

import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

import 'font-awesome/css/font-awesome.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'flatpickr/dist/flatpickr.min.css';

import '../../components/grid/styles.scss';
import '../../components/grid/slickgrid.scss';
import '../../layouts/gridlayout.css'
import i18next, { TFunction } from 'i18next';

import ContactService from "../../services/contractor/contacts.service";
import ContractorService from "../../services/contractor/contractor.service";
import { ColorEditor } from '../../components/grid/CustomEditors/ColorEditor';
import emailService from '../../services/email/email.service';

import {
   SlickgridReact, FieldType, Filters,
   GridOption,
  Column, Formatter, Formatters,
  Editors, EditCommand, 
  CompositeEditorModalType, OnCompositeEditorChangeEventArgs, CompositeEditorSelection,
  InputEditor,
  SlickGrid,
  OnAddNewRowEventArgs,
  EditorValidator,
  CurrentSorter,
  EmitterType,
  SlickgridReactInstance,
} from 'slickgrid-react';

import { ExcelExportService } from '@slickgrid-universal/excel-export';
import { OdataOption, OdataServiceApi } from '@slickgrid-universal/odata';


import BaseGrid, {BasicGridProps} from '../../components/grid/BaseGridComponent';
import { TextOperators } from '../../components/grid/CustomFilters/TextFilter';
import { SlickCustomTooltip } from '@slickgrid-universal/custom-tooltip-plugin';
import authService from '../../services/auth/auth.service';
import { LookupCollection, LookupData } from '../../components/grid/GridUtils';

import { withTranslation } from 'react-i18next';
import { InputAdornment, TextField , Tooltip} from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import BorderSpinner from '../../components/Layout/spinner';


const location = window.location
  
const locationley = location.pathname.replace('/', '')
const LOCAL_STORAGE_SEARCH = authService.getCurrentUser()?.shrt + '_crm-' + locationley + '-search' 

const resources = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  },
  pl: {
    translation: translationPL
  }
};

async function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      resolve(reader.result)
    }
    reader.onerror = reject
  })
}

class Contacts extends BaseGrid {
  
    title = 'Kontakty';
    subTitle = 'Zarządzanie kontaktami'
    lastApiCall;
    own_contractor_groups;
    queryParameters;

    attachements;
    attachement_names;

 constructor(props) {
    super(props);
    this.lastApiCall = new Date(0)
    this.own_contractor_groups = []
    this.queryParameters = new URLSearchParams(window.location.search)
    this.attachements = []
    this.attachement_names = []
 }

 hideModal(){
  var modal = document.getElementById('sendEmailModal');
	if (modal){
    modal.style.display = "none";
  }
}



sendMailSubmit =  (e) => { 
	//console.log($('#mail_subject').val());
	
	var selectedCount=0;
	var list='';
	var selectedData = [],
  selectedIndexes;
	var list='';
	var selectedCount=0;
	list  = 	String(jQuery('#mail_recipient').val());
	var tmp = list.split(';');
  var subject = 	jQuery('#mail_subject').val() ; 
//console.log(tmp);	
//console.log(window.tinyMCE.activeEditor.getContent())
//console.log('AAA')
//console.log(this.state.customEditor)
	selectedIndexes = tmp.length; //grid.getSelectedRows();
	if (selectedIndexes>0){
	  if (window.confirm('Ilość maili do wysłania: '  + selectedIndexes + '\nCzy potwierdzasz?')){
      //alert('Wysłano')
      var that= this
      
      //emailService.addMail(list, this.state.customEditor, subject ).then( async data => {
      emailService.addMail(list, window.tinyMCE.activeEditor.getContent(), subject ).then( async data => {
        var id = data;
       
        if (this.attachements && this.attachements.length > 0) {
          for (var x = 0; x < this.attachements.length; x++) {
            //console.log('AAAAA')
            //console.log(this.attachement_names[x])
            emailService.addAttachment(id, this.attachements[x], this.attachement_names[x]).then(data =>{
              alert('Mailing został zapisany!')
            }).catch(error => {
              alert('Błąd podczas zapisu załączników!')
            });
          }
        }else{
          alert('Mailing został zapisany!')
        }

      }).catch( error => {
        console.log(error)
        alert('Błąd podczas tworzenia mailingu!')
      })
      
    //  contractorService.savemailData().then( (resp) => {

    //  }).catch( error => {
    //    console.log(error)
    //  })
    }
  }
}


sendMails(){
  var selectedCount=0;
  var list='';
  var selectedData = [],
      selectedIndexes;
  var list='';
  var selectedCount=0;
  //jQuery('#files').val('');
  //$('#mail_subject').val('');
  this.setState((state, props) => ({
    ...state,
    customEditor: '',
  }));

 // ($("#tinymce1") as Editor).editor.setContent("");
  
 var csvData = this.reactGrid.slickGrid.getSelectedRows().map((index)=> {return this.reactGrid.slickGrid.getDataItem(index).id});

  list = csvData.join(',')
  
  selectedIndexes = this.reactGrid.slickGrid.getSelectedRows();

 console.log("Selected Indexes: " + selectedIndexes)

  ContactService.getmails(list).then( (resp) => {
    //console.log(resp)
    console.log("Selected mails: " + resp)
    //$('#mail_recipient').val(resp);
					
		var modal = document.getElementById('sendEmailModal');

    if (modal){
		  modal.style.display = "block";
      jQuery('#mail_recipient').val(resp);
    }

  }).catch( error => {
    console.log(error)
  })

}


imageChange = async (e) => {
  if (e.target.files && e.target.files.length > 0) {
    var b64 = String(await getBase64(e.target.files[0]))
    this.attachements.push(b64)
    this.attachement_names.push(e.target.files[0].name)
  }
};

 reactGridReady(reactGrid) {
  super.reactGridReady(reactGrid);
  if (this.queryParameters){ 
    var group_name = this.queryParameters.get("group_name")
      if (group_name!=null && group_name!=''){
        this.reactGrid.filterService.updateFilters([
              { columnId: 'group_names_array', searchTerms: [group_name.trimStart()] }
              ]); 	
              window.location.replace("/contacts")      
      }
  }
}

setSearchFilter() {
  if (this.reactGrid && localStorage[this.search_key] && localStorage[this.search_key]!==''){
    this.reactGrid.filterService.updateFilters([])

  }else{
    if (this.reactGrid){
       this.reactGrid.filterService.clearFilters()
    }
  }
}

  
onStorage = () => {
  this.setSearchFilter()
};
onFocus = () => {
  window.addEventListener("storage", this.onStorage)
};
onBlur = () => {
  window.removeEventListener("storage", this.onStorage)
};
  
componentDidMount() {
    window.addEventListener("resize",((e) =>{
      setTimeout(() => { this.reactGrid.resizerService.resizeGrid(); }, 1000);
      
  }).bind(this));

  window.addEventListener("focus", this.onFocus);
  window.addEventListener("blur", this.onBlur);
  this.onFocus();
 //this.defineGrid()

 this.getlookups();
    i18next.init({
      lng: 'pl',
      debug: false,
      resources: resources
    }, (err, t) => {
      i18next.changeLanguage("pl");
      
    });
  
}

 defineGrid() {
    var presets = JSON.parse(localStorage[this.storage_key] || null);

    if (presets){
      var new_sorters = presets.sorters.map((element) => {
        element.columnId = (element.columnId).toLowerCase();
        return element;
      });
      presets.sorters = new_sorters;
    }
   
    var gridOptions =  this.getGridDefinition();
    gridOptions.presets = presets

    var columnDefinitions = this.getColumnDefinitions();

    this.setState((state) => ({
      ...state,
      gridOptions:gridOptions,
      columnDefinitions:columnDefinitions,
    
  }));
}

componentDidUpdate(PrevProps, prevState){

  window.tinymce.init({selector: '#tinymce1', 

    setup: (editor) => {
      editor.on("change", (e) => {
         this.setState((state, props) => ({
           ...state,
           customEditor: e.target.getContent(),
         }));

      });
    },

    height: 500, 
    //language: 'pl',
    //menubar: false,
    
    license_key: 'gpl',
    plugins: 'advlist autolink lists link image charmap preview anchor \
              searchreplace visualblocks code fullscreen \
                    insertdatetime media table code help wordcount',
    
    automatic_uploads: false,
    file_picker_types: 'image',
    image_description:true,
    paste_data_images: true,


    file_picker_callback: (callback, value, meta) => {

      var input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
    
        input.onchange = async function(e) {
          var file = input.files? input.files[0] : null
          //var aaa=field_name;
          var reader = new FileReader();
          if (file) {
            var b64 = String(await getBase64(file))
            callback(b64, { text: 'My text' });
            }
          
          reader.onload = function (e) {
            var id = 'blobid' + (new Date()).getTime();
            
          };
        };
    
        input.click();	        
    },
    file_browser_callback : function myFileBrowser (field_name, url, type, win) {
        if (type=='image'){
        var input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
    
        input.onchange = async function() {
          var aaa=field_name;
          var reader = new FileReader();
          reader.onload = function () {
            var id = 'blobid' + (new Date()).getTime();
          };
        };
    
        input.click();	
        }
        return false;
    },
    

    toolbar:
          'undo redo | formatselect | bold italic backcolor | \
          alignleft aligncenter alignright alignjustify | \
          bullist numlist outdent indent | removeformat | help',

      
          
  }); 
  
  if(this.state.alertErrorMsg !== prevState.alertErrorMsg){
      if (this.state.alertErrorMsg){
        //alert(this.state.alertErrorMsg)
      }
  }   
  
}


  getGridDefinition() {    
      var tmp = super.getGridDefinition(this.state);
      tmp = {
        ...tmp,
        enableTranslate: true,
        i18n: i18next,
        autoResize: {
          container: '#smaller-container',
          rightPadding: 10
        },
        enableExcelExport : true,
        excelExportOptions: {
          sanitizeDataExport: true,
          
        },
        externalResources: [this.excelExportService, this.compositeEditorInstance, new SlickCustomTooltip()],
        
        editCommandHandler: (_item, _column, editCommand) => {
          var data = _item
  
          this._commandQueue.push(editCommand);
          editCommand.execute();
          this.editContactApiCall(data);
        },
        presets: {},
        
        backendServiceApi: {
          ...tmp.backendServiceApi,
          onError: (error: Error) => {
              this.setState((state: State, props: BasicGridProps) => ({
                ...state,
                alertError: "Błąd połączenia!"
              }));  
          },
          preProcess: () => {
            this.setState((state: State) => ({ ...state, errorStatus: '' }));
            this.displaySpinner(true);
          },
          process: (query) => {
            if (localStorage[this.search_key] && localStorage[this.search_key]!=''){
              query=query + "&$search=" + localStorage[this.search_key].replace('&', 'i') 
            }
            return this.getContactApiCall(query)},
          postProcess: (response) => {
            if (new Date(response.metrics.startTime) > this.lastApiCall){
              this.lastApiCall = new Date(response.metrics.startTime)
              this.setState(
                (state: State) => ({ ...state, metrics: response.metrics }),
                () => this.postProcessCallback(response)
              );
            }
            this.displaySpinner(false);
          },
        } 
      }
    return tmp;
  }

  onCellValidationError(_e, args) {
    if (args.validationResults) {
      this.setState((state, props) => ({
        ...state,
        alertWarning: args.validationResults.msg
      }));
    }
  }

  deleteFormatter(row, cell, value, column, dataContext, grid) {
    const tooltipTitle = 'Usuń kontakt';
    return '<div class="header-tooltip-title">${tooltipTitle}</div>'
  }

  
  groupFormatter =  (row, cell, value, columnDef, dataContext) => {
    var s="";
    
    if (dataContext.group_names !=null){
      
        if (Array.isArray(dataContext.group_names)){
            s = dataContext.group_names.join(',');
        }else{
            var array = dataContext.group_names.split(',');
           
            for (var a in array ) {
            if (s!=""){
                s+=", ";
            }	
              
            s +="<a class='slickRowLink' href='/contacts?group_name=" +  array[a] + "' >" + array[a] + "</a>";
           
            }
        }
    
    }
     return s;
 };

 labelFormatter =  (row, cell, value, columnDef, dataContext) => {
  var s="";
  if (dataContext.labels !=null){
      if (Array.isArray(dataContext.labels)){
          s = dataContext.labels.join(',');
      }else{
          var array = dataContext.labels.split(',');
          
          for (var a in array ) {
          if (s!=""){
              s+=", ";
          }	
          s +="<a class='slickRowLink' href='/contractors?label=" +  array[a] + "' >" + array[a] + "</a>";
          
          }
      }
  
  }
   return s;
};


nameFormatter = (row, cell, value, columnDef, dataContext) =>{
  var ownContractor = authService.isAdmin() 
  if (!ownContractor){
    if (this.own_contractor_groups &&  Array.isArray(this.own_contractor_groups) &&  this.own_contractor_groups.length>0){
       for (const group in dataContext?.group_names_array){
         if (this.own_contractor_groups.includes(dataContext?.group_names_array[group])){ 
          ownContractor = true;
            break;
         }  
       }
    }else{
      ownContractor = false;
    }
  }
  let s=""
  if ( dataContext.contractor_name !=null){
    if (ownContractor){
      s ="<a class='slickRowLink' href='/contractors/card/" + dataContext.contractor_id + "' >" + dataContext.contractor_name + "</a>";
    }else{
       s=dataContext.contractor_name
    } 
  }
  return s;
  
  
  
};

  maxLen100Validator  = (value) => {
    let ready=false
    if (value === null || value === undefined || !value.length) {
      return { valid: true, msg: '' };
    }else if (value.length > 100){
      return {
        valid: false,
        msg: 'To pole przyjmuje maksymalnie 100 znaków',
      }
    }else{
      return {
        valid: true,
        msg: '',
      }
    }
  }

  requiredNameValidator  = (value) => {
    let ready=false
    if (value === null || value === undefined || !value.length) {
      return {
        valid: false,
        msg: 'To pole jest wymagane',
       }
    }else if (value.length > 255){
      return {
        valid: false,
        msg: 'To pole przyjmuje maksymalnie 255 znaków',
      }
    }else{
      return {
        valid: true,
        msg: '',
      }
    }
  }

  phoneValidator = (value) => {

    if (value.length>100) {
    return {
        valid: false,
        msg: 'To pole przyjmuje maksymalnie 100 znaków',
    };
    }else if (/[a-zA-Z]+/.test(value)){
    return { valid: false, msg: 'Numer telefonu nie może zawierać liter [a-z A-Z]' };
    }
    return { valid: true, msg: '' };
};

emailValidator = (value) => {
  if (!(value === null || value === undefined || !value.length)) {
    if (value.length>100) {
        return {
        valid: false,
        msg: 'To pole przyjmuje maksymalnie 100 znaków',
        };
    }else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,8}$/.test(value)){
        return { valid: false, msg: 'Nieprawidłowy format adresu e-mail' };
    }
  }
  return { valid: true, msg: '' };
};



 
getlookups(){
  return ContractorService.getcontractorlookups().then(response => {

    let tmp1 = []
    if ((response.data) && (Array.isArray(response.data))){
        tmp1  = response.data
    }
    this.setState((state) => ({
      ...state,
      lookupData : tmp1
    }),  () => {
      ContractorService.getOwnContractorGroups().then(response => { 
        if ((response) && (Array.isArray(response))){
          this.own_contractor_groups = response  
        }else{
          this.own_contractor_groups = []
        }
        this.defineGrid()
      }
      ).catch(
        () => {
          let tmp = [];
          this.setState((state, props) => ({
                ...state,
                alertError: "Nie wszystkie dane zostały poprawnie zaczytane - odśwież stronę!"
          }));
          this.own_contractor_groups=[]
          return tmp;
        }
      )

     

      }
    );


}
 
).catch(
() => {
  let tmp = [];
  this.setState((state, props) => ({
        ...state,
        alertError: "Nie wszystkie dane zostały poprawnie zaczytane - odśwież stronę!"
  }));
  return tmp;
}
)
}

  

  getColumnDefinitions(){
    super.getColumnDefinitions()
    let tmp  = []; 
    let data_contractorgroups= [];
    let data_fairs  = [];
    let data_contractortrades = [];
    let data_contractorstates =[];

    this.state.lookupData?.forEach((item) => {
      if (item.name === 'contractorgroups'){
        data_contractorgroups = item.data; 
      }else if (item.name === 'fairs'){
        data_fairs = item.data; 
      }
      else if (item.name === 'contractortrades'){
        data_contractortrades = item.data; 
      }else if (item.name === 'contractorstates'){
        data_contractorstates = item.data; 
      } 
    })
   // if (authService.isAdmin()){
      tmp.push(
        {
          id: 'delete', field: 'id',
          excludeFromColumnPicker: true, excludeFromGridMenu: true,excludeFromHeaderMenu: true,
          formatter: Formatters.icon, params: { iconCssClass: 'fa fa-trash pointer' }, minWidth: 30, maxWidth: 30,  
          customTooltip: {
            formatter:  this.deleteFormatter.bind(this) 
          },    
        }
      );
   // }

    tmp.push(
      {
        id: 'row_no', name: 'Lp.', field: 'row_no', sortable: false, filterable: false,
        type: FieldType.integer,
        minWidth:30 ,
        maxWidth:50    
      },
      {
        id: 'position', name: 'Stanowisko', field: 'position', sortable: true, filterable: true,
        type: FieldType.string,
        excludeFromColumnPicker: true,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          compositeEditorFormOrder : 2,
          validator : this.maxLen100Validator
        },
        hidden:false,
        minWidth:100      
      },
      {
        id: 'name', name: 'Nazwa', field: 'name', sortable: true, filterable: true,
        type: FieldType.string,
        excludeFromColumnPicker: true,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          compositeEditorFormOrder : 2,
          validator : this.requiredNameValidator
          
        },
        hidden:false,
        minWidth:100      
      },
      {
        id: 'contractor_name', name: 'Nazwa kontrahenta', field: 'contractor_name', sortable: true, filterable: true,
        type: FieldType.string,
        excludeFromColumnPicker: false,
        //formatter:this.taskTranslateFormatter,
        formatter:this.nameFormatter,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        hidden:false,
        minWidth:100
             
      },
      {
        id: 'group_names_array', name: 'Grupa', field: 'group_names_array', sortable: true, filterable: true,
        type: FieldType.string,
        formatter: this.groupFormatter,
        filter: {model: Filters.multipleSelect, compoundOperatorList: TextOperators, collection:data_contractorgroups},
        excelExportOptions: {
          valueParserCallback: (data, col, excelFormatterId, excelStylesheet) => {
            if (Array.isArray(data)){
              return data.join(',');
            }
            return data;
          }
        },
        queryField: 'group_names',
        minWidth:100
      },
      {
        id: 'labels_array', name: 'Etykiety', field: 'labels_array', sortable: true, filterable: true, 
        excelExportOptions: {
            valueParserCallback: (data, col, excelFormatterId, excelStylesheet) => {
              if (Array.isArray(data)){
                return data.join(',');
              }
              return data;
            }
          },
        
        type: FieldType.string,
        formatter: this.labelFormatter,
        filter: {model: Filters.multipleSelect, compoundOperatorList: TextOperators, collection:data_fairs},
        queryField: 'labels',
        minWidth:100
      },
      {
        id: 'trade_name', name: 'Branża', field: 'trade_name', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.multipleSelect, collection:data_contractortrades, compoundOperatorList: TextOperators},
        
        minWidth:100
      },
      {
        id: 'contractor_state', name: 'Status', field: 'contractor_state', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.multipleSelect, collection:data_contractorstates, compoundOperatorList: TextOperators},
        minWidth:100
      },
      {
        id: 'phone', name: 'Telefon', field: 'phone', sortable: true, filterable: true,
        type: FieldType.string,
        excludeFromColumnPicker: true,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          compositeEditorFormOrder : 2,
          validator : this.phoneValidator
        },
        hidden:false,
        minWidth:100      
      },
      {
        id: 'mail', name: 'E-mail z NL', field: 'mail', sortable: true, filterable: true,
        type: FieldType.string,
        excludeFromColumnPicker: true,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          compositeEditorFormOrder : 2,
          validator : this.emailValidator
          
        },
        hidden:false,
        minWidth:100      
      },
      {
        id: 'unsub_eml', name: 'Email rezygnacja z NL', field: 'unsub_eml', sortable: true, filterable: true,
        type: FieldType.boolean,
        formatter: Formatters.checkmark,
        filter: {
          model: Filters.singleSelect,
          collection: [
            { value: '', label: '' },
            { value: 1, label: 'Tak' },
            { value: 0, label: 'Nie' },
          ],
        },
        editor: {model: Editors.checkbox,
          compositeEditorFormOrder : 14,
        },
        
        minWidth:50
      },
      {
        id: 'inactive_eml', name: 'Email nieaktywny', field: 'inactive_eml', sortable: true, filterable: true,
        type: FieldType.boolean,
        formatter: Formatters.checkmark,
        filter: {
          model: Filters.singleSelect,
          collection: [
            { value: '', label: '' },
            { value: 1, label: 'Tak' },
            { value: 0, label: 'Nie' },
          ],
        },
        editor: {model: Editors.checkbox,
          compositeEditorFormOrder : 14,
        },
        
        minWidth:50
      },
      {
        id: 'unsub_tel', name: 'Telefon rezygnacja z NL', field: 'unsub_tel', sortable: true, filterable: true,
        type: FieldType.boolean,
        formatter: Formatters.checkmark,
        filter: {
          model: Filters.singleSelect,
          collection: [
            { value: '', label: '' },
            { value: 1, label: 'Tak' },
            { value: 0, label: 'Nie' },
          ],
        },
        editor: {model: Editors.checkbox,
          compositeEditorFormOrder : 14,
        },
        
        minWidth:50
      },
     
      {
        id: 'modified', name: 'Data edycji', field: 'modified', sortable: true, filterable: true,
        type: FieldType.dateTimeIso,
        formatter:Formatters.dateTimeIso,
        filter: {model: Filters.dateRange, filterOptions:{enableTime:false}},           
        hidden:false,
        minWidth:100   
      },
      {
        id: 'created', name: 'Data utworzenia', field: 'created', sortable: true, filterable: true,
        type: FieldType.dateTimeIso,
        formatter:Formatters.dateTimeIso,
        filter: {model: Filters.dateRange, filterOptions:{enableTime:false}},           
        hidden:false,
        minWidth:100   
      },
     
         
    );

    tmp = this.customizeHeaderMenu(tmp)

    return tmp
  }

   

  deleteFairFormatter(row, cell, value, column, dataContext, grid) {
    const tooltipTitle = 'Usuń';
    return `<div class="header-tooltip-title">${tooltipTitle}</div>
    <div class="tooltip-2cols-row"><div>Etykieta:</div> <div>${dataContext.label}</div></div>`;
  }

  getContactApiCall(query) {
    return ContactService.getContacts(query)
  }
  editContactApiCall(data) {   
    ContactService.editContact(data).then(
      
      ).catch(
         (error) => {
          try{
            this._commandQueue.pop()?.undo()
            this.setState((state, props) => ({
              ...state,
              alertError: "Błąd edycji danych"
            }));
          }catch{

          }
        }
      )
  }

  sortCollectionDescending(collection) {
    return collection.sort((item1, item2) => item1.value - item2.value);
  }

  openCompositeModal(modalType) {
    let modalTitle = '';
    if (this.reactGrid.slickGrid.getEditorLock().isActive() && !this.reactGrid.slickGrid.getEditorLock().commitCurrentEdit()) {
      return;
    }
      switch (modalType) {
        case 'create':
          modalTitle = 'Dodawanie nowego kontaktu';
          break;
        case 'clone':
          modalTitle = 'Kopiowanie kontaktu - {{name}}';
          break;
        case 'edit':
          var selecttedcount =  this.reactGrid.slickGrid.getSelectedRows();
          if (selecttedcount.length > 1){
            modalTitle = 'Edycja wybranych rekordów (' + selecttedcount + ')';
            modalType = 'mass-selection';
          }else{
            modalTitle = 'Edycja kontaktu'; // 'Editing - {{title}} ({{product.itemName}})'
          }
          break;
      }
      var modalColumns = this.reactGrid.slickGrid.getColumns(). filter(col => col.editor);

    if (modalType==='edit'){
      if (this.reactGrid.slickGrid.getSelectedRows() && (this.reactGrid.slickGrid.getSelectedRows().length===1)){
        this.compositeEditorInstance?.openDetails({
          headerTitle: modalTitle,
          modalType,
          insertOptions: { highlightRow: false }, 
          showFormResetButton: true,
          resetFormButtonIconCssClass: 'fa fa-undo',
          
          onClose: () => Promise.resolve(window.confirm('Istnieją niezapisane zmiany, czy na pewno chcesz wyjść bez zapisywania zmian?')),
          onError: (error) => alert(error.message),
        });
      }else if (this.reactGrid.slickGrid.getSelectedRows() && (this.reactGrid.slickGrid.getSelectedRows().length>1)){
        alert('Wybież jeden kontakt do edycji!');
      }else{
        alert('Nie wybrano kontaktu do edycji!');
      }
    }else{
        this.compositeEditorInstance?.openDetails({
            headerTitle: modalTitle,
            modalType,
            insertOptions: { highlightRow: false }, 
            showFormResetButton: true,
            resetFormButtonIconCssClass: 'fa fa-undo',
          
            
          onClose: () => Promise.resolve(window.confirm('Istnieją niezapisane zmiany, czy na pewno chcesz wyjść bez zapisywania zmian?')),
          onError: (error) => alert(error.message),
          onSave: (formValues, _selection, dataContext) => {
            if (_selection.gridRowIndexes.length===0){
              let tmp = {...dataContext, id:null}
              ContactService.addContact(tmp).then(
                  (data) => {
                    this.reactGrid.filterService.updateFilters([])
                  }
                ).catch(
                  (error) => {
                    try{   
                      if (error && error.response && error.response.data && error.response.data.detail){
                        this.setState((state, props) => ({
                          ...state,
                          alertError: "Błąd: " + error.response.data.detail
                        }));
                      }else{          
                        this.setState((state, props) => ({
                          ...state,
                          alertError: "Błąd podczas dodawania kontaktu"
                        }));
                      }
                      
                      var tmp = this.reactGrid.slickGrid.getData().getItems()
                      tmp.splice(0,1);
                      
                      this.reactGrid.slickGrid.getData().setItems(tmp)
                    }catch{
          
                    }
                  }
                )   
            }
          const serverResponseDelay = 50;
          return new Promise(resolve => setTimeout(() => resolve(true), serverResponseDelay));
        }
      });
    }
  }
    
  onCellClicked(_e, args) {
    const metadata = this.reactGrid.gridService.getColumnFromEventArguments(args);

    if (metadata.columnDef.id === 'delete') {
      if (this.checkItemIsEditable(metadata.dataContext, metadata.columnDef, this.reactGrid.slickGrid)){
        if (window.confirm('Czy potwierdzasz usunięcie kontaktu: ' + metadata.dataContext.name + '?')) {
          ContactService.deleteContact(metadata.dataContext.id).then(
            () => {
              this.reactGrid.gridService.deleteItemById(metadata.dataContext.id)

              this.setState((state, props) => ({
                ...state,
                alertInfo: `Usunięto: ${metadata.dataContext.name}`,
              }));
          }

          ).catch(
            () => {
              this.setState((state, props) => ({
                ...state,
                alertError: `Wystąpił problem przy usuwaniu kontaktu: ${metadata.dataContext.name}`,
              }));
            }
          )
          
          
        }
      }else{
        alert('Nie masz uprawnień do usunięcia wybranego kontaktu!')
      }
    }
  }

  checkItemIsEditable(dataContext, columnDef, grid) {
    const gridOptions = grid.getOptions();
    const hasEditor = columnDef.editor;
    const isGridEditable = gridOptions.editable;
    let isEditable = Boolean(isGridEditable && hasEditor);
  
    if (dataContext && columnDef && gridOptions?.editable) {
      isEditable = authService.isAdmin()
      if (!isEditable){
        if (this.own_contractor_groups &&  Array.isArray(this.own_contractor_groups) &&  this.own_contractor_groups.length>0){
          for (const group in dataContext?.group_names_array){
            if (this.own_contractor_groups.includes(dataContext?.group_names_array[group])){ 
              isEditable = true;
              break;
            }  
          }    
        }else{
          isEditable = false;
        }
      
      }
    }
    return isEditable;
  }

  handleonAddNewRow(_e, args) {
     //return true;
  }

  handleOnCompositeEditorChange(_e, args) {
    
  }

  handleOnBeforeEditCell(e, args) {
    const { column, item, grid } = args;

    if (column && item && !this.checkItemIsEditable(item, column, grid)) {
      e.stopImmediatePropagation();
      return false;
    }
    return true;
  }

  resizeContent($event){
 
  }

  render() {
    if (this.state.alertWarning) {
      enqueueSnackbar(this.state.alertWarning, {variant: 'warning', preventDuplicate: true, autoHideDuration:5000, persist: false})
      this.setState((state, props) => ({
        ...state,
        alertWarning: ''
      }));
    }
    if (this.state.alertError) {
      enqueueSnackbar(this.state.alertError, {variant: 'error', preventDuplicate: true, autoHideDuration:5000, persist: false})
      this.setState((state, props) => ({
        ...state,
        alertError: ''
      }));
    }

    if (this.state.alertInfo) {
      enqueueSnackbar(this.state.alertInfo, {variant: 'info', preventDuplicate: true, autoHideDuration:5000, persist: false}) 
      this.setState((state, props) => ({
        ...state,
        alertInfo: ''
      }));
    }

    return !this.state.gridOptions ? '' : (
       <>

          {/* The Modal */}
          <div id="sendEmailModal" className="modal">
            {/* Modal content */}
            <div className="modal-content">
              <div className="modal-header">
                <form id="frmSendMail" style={{width:"100%"}} >
                  <span className="close" onClick={() =>{this.hideModal()}}>×</span>
                  <div style={{textAlign: 'center'}}>Wysyłanie wiadomości e-mail</div>
                  <div style={{float: 'left', width: 100, textAlign: 'right'}}>Do: </div><div style={{float: 'left', marginLeft: 20, width: '90%', color: '#000!important'}}><input type="text" style={{width: '90%'}} name="mail_recipient" id="mail_recipient" /></div>
                  <div style={{clear: 'both'}} />
                  <div style={{float: 'left', width: 100, textAlign: 'right'}}>Temat:</div><div style={{float: 'left', marginLeft: 20, width: '90%', color: '#000!important'}}><input style={{marginTop: 5, width: '90%'}} type="text" name="mail_subject" id="mail_subject" /></div>
                  <div style={{clear: 'both'}} />
                </form></div>
                <div style={{float: 'left', width: 100, textAlign: 'right'}}>Treść: </div><div style={{float: 'left', marginLeft: 20, width: '90%', color: '#000!important'}}></div>  
              <div className="modal-body">
              
              <textarea style={{height: 500, width:'100%'}} id="tinymce1"></textarea>
              
               
              </div>
              <div className="modal-footer">
                <input  onChange={this.imageChange} type="file" id="files" name="files[]" multiple={true} />
                <button type="button" data-content="remove" className="btn btn-default" data-dismiss="modal" onClick={() => {this.hideModal()}}>Anuluj</button>
                <button type="button" data-content="remove" className="btn btn-primary" id="edtUserInGroupsBtn" onClick={(e) =>{this.sendMailSubmit(e)}}>Wyślij</button>
              </div>
            </div>
          </div>

          <div className="gridMenu">
            <div className='gridLeftSubMenu'> 
              <FormControlLabel id="lblautoedit" control={<Switch checked={this.state.isAutoEdit} onChange={(_, data) => this.autoeditchange(data)}  />} label="Auto-edit" />

              
            </div>
            
            
            <div className='gridCenterSubMenu'>
            
           { authService.isAdmin() && <button className="btn btn-outline-secondary btn-sm mx" data-test="clear-sorting"
                  onClick={() => {this.openCompositeModal('create')} 
            }>
                  Dodaj
                </button>
            }
           
              
            <button className="btn btn-outline-secondary btn-sm mx-1" data-test="clear-sorting"
              onClick={() => this.openCompositeModal('edit')}>
                Edytuj
            </button>

            <button className="btn btn-outline-secondary btn-sm mx-1" data-test="clear-sorting"
              onClick={this.sendMails.bind(this)}
              >
                <Tooltip title="Mail">
                <i className="fas fa fa-at nav-icon" />
                </Tooltip>
            </button>
              
            </div><div className='gridRightSubMenu'>
                <button className="btn btn-outline-secondary btn-sm mx-1" data-test="set-dynamic-sorting"
                  onClick={() => this.setFactorySettings()}>
                  Ustawienia domyślne
                </button>

              </div>
          </div>
          <div id="smaller-container" onResize={this.resizeContent} style={{ width: '100%' }}>
          {this.state.status.text =='loading' ? <BorderSpinner/> : ''}
          
          <SlickgridReact gridId="contact-grid"
            columnDefinitions={this.state.columnDefinitions}
            gridOptions={this.state.gridOptions}
            dataset={this.state.dataset}
            paginationOptions={this.state.paginationOptions}
            onReactGridCreated={$event => this.reactGridReady($event.detail)}
            onGridStateChanged={$event => this.gridStateChanged($event.detail)}
            onClick={e => { this.onCellClicked(e.detail.eventData, e.detail.args); }}  
            onBeforeEditCell={$event => this.handleOnBeforeEditCell($event.detail.eventData, $event.detail.args)}   
            onCompositeEditorChange={$event => this.handleOnCompositeEditorChange($event.detail.eventData, $event.detail.args)}
            onAddNewRow={$event => this.handleonAddNewRow($event.detail.eventData, $event.detail.args)}
            onValidationError={e => { this.onCellValidationError(e.detail.eventData, e.detail.args); }}
            
            
          />
          </div>
      </>
    );
  }
}

export default withTranslation()(Contacts);